import { useState } from "react";
import { Box, Grid, Typography, Link, IconButton } from "@mui/material";
import { Facebook, Instagram } from "@mui/icons-material";
import XIcon from "@mui/icons-material/X"; // For the "X" (Twitter) logo
import ScrollToTopButton from "./Utilities/ScrollToTopButton";
import ComingSoonSnackbar from "./Utilities/ComingSoonSnackbar";

const Footer = () => {
  const [comingSoonOpen, setComingSoonOpen] = useState(false);

  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        color: "#1a1a2e",
        py: { xs: 4, md: 6 },
        px: { xs: 3, sm: 6, md: 10 },
        mt: "50px",
        borderTop: "4px solid #1d2c61",
      }}
    >
      <ScrollToTopButton />

      {/* TOP GRID LINKS */}
      <Grid container size={12} spacing={5}>
        {/* ACCOUNTS */}
        <Grid
          item
          // size={1.5}
          xs={6}
          sm={4}
          md={2}
          textAlign={{ xs: "left", sm: "left" }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: '#1d2c61' }}>
            ACCOUNTS
          </Typography>
          {[
            { name: "Account Types", path: "/accountsTypesAccount" },
            { name: "Starter", path: "/starterAccount" },
            { name: "Pro Trader", path: "/proTraderAccount" },
            { name: "Zero Spread", path: "/zeroSpreadAccount" },
            { name: "Elite", path: "/eliteAccount" },
          ].map(({ name, path }) => (
            <Typography key={name} sx={{ mb: 1 }}>
              <Link
                href={path}
                underline="none"
                sx={{
                  color: "#333",
                  fontSize: "15px",
                  "&:hover": { textDecoration: "none", color: "#1d2c61", fontWeight: "600" },
                  textAlign: "left",
                }}
              >
                {name}
              </Link>
            </Typography>
          ))}
        </Grid>

        {/* MARKETS */}
        <Grid
          item
          paddingRight={2}
          paddingLeft={2}
          xs={6}
          sm={4}
          md={2}
          textAlign="left"
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: '#1d2c61' }}>
            MARKETS
          </Typography>
          {[
            { name: "Forex", path: "/forexMarket" },
            { name: "Metals", path: "/metalsMarket" },
            { name: "Indices", path: "/indicesMarket" },
            { name: "Stocks", path: "/stocksMarket" },
            { name: "Commodities", path: "/commoditiesMarket" },
            { name: "Cryptocurrencies", path: "/cryptocurrencyMarket" },
          ].map(({ name, path }) => (
            <Typography key={name} sx={{ mb: 1 }}>
              <Link
                href={path}
                underline="none"
                sx={{
                  color: "#333",
                  fontSize: "15px",
                   "&:hover": { textDecoration: "none", color: "#1d2c61", fontWeight: "600" },
                  textAlign: "left",
                }}
              >
                {name}
              </Link>
            </Typography>
          ))}
        </Grid>

        {/* TRADING */}
        <Grid
          item
          paddingRight={2}
          paddingLeft={2}
          xs={6}
          sm={4}
          md={2}
          textAlign="left"
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: '#1d2c61' }}>
            TRADING
          </Typography>
          {[
            { name: "Swaps", path: "/swapMarket" },
            { name: "Margin & Leverage", path: "/marginLeverage" },
            { name: "Deposit & Withdrawals", path: "/depositWithdrawal" },
          ].map(({ name, path }) => (
            <Typography key={name} sx={{ mb: 1 }}>
              <Link
                href={path}
                underline="none"
                sx={{
                  color: "#333",
                  fontSize: "15px",
                   "&:hover": { textDecoration: "none", color: "#1d2c61", fontWeight: "600" },
                  textAlign: "left",
                }}
              >
                {name}
              </Link>
            </Typography>
          ))}
        </Grid>

        {/* PLATFORMS */}
        <Grid
          item
          paddingRight={2}
          paddingLeft={2}
          xs={6}
          sm={4}
          md={2}
          textAlign="left"
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: '#1d2c61' }}>
            PLATFORMS
          </Typography>
          {[
            { name: "Web Terminal", path: "https://trade.hcfinvest.com/user/login" },
            { name: "Android App", path: "https://play.google.com/store/apps/details?id=com.metaquantpro.app" },
          ].map(({ name, path }) => (
            <Typography key={name} sx={{ mb: 1 }}>
              <Link
                href={path}
                underline="none"
                target="_blank"
                sx={{
                  color: "#333",
                  fontSize: "15px",
                   "&:hover": { textDecoration: "none", color: "#1d2c61", fontWeight: "600" },
                  textAlign: "left",
                }}
              >
                {name}
              </Link>
            </Typography>
          ))}
          <Typography sx={{ mb: 1 }}>
            <Link
              component="button"
              underline="none"
              onClick={() => setComingSoonOpen(true)}
              sx={{
                color: "#333",
                fontSize: "15px",
                "&:hover": { textDecoration: "none", color: "#1d2c61", fontWeight: "600" },
                textAlign: "left",
              }}
            >
              iOS App
            </Link>
          </Typography>
        </Grid>

        {/* COMPANY & SOCIAL LINKS */}
        <Grid
          item
          paddingRight={2}
          paddingLeft={2}
          xs={12}
          sm={6}
          md={4}
          textAlign="left"
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: '#1d2c61' }}>
            COMPANY
          </Typography>
          {[
            { name: "About Us", path: "/about" },
            { name: "Contact Us", path: "/contactUs" },
            { name: "Help Center", path: "/helpCenter" },
          ].map(({ name, path }) => (
            <Typography key={name} sx={{ mb: 1 }}>
              <Link
                href={path}
                underline="none"
                sx={{
                  color: "#333",
                  fontSize: "15px",
                  "&:hover": { textDecoration: "none", color: "#1d2c61", fontWeight: "600" },
                  textAlign: "left",
                }}
              >
                {name}
              </Link>
            </Typography>
          ))}

          <Typography variant="subtitle1" sx={{ fontWeight: 700, mt: 3, color: '#1d2c61' }}>
            Connect
          </Typography>
          <Box sx={{ display: "flex", mt: 1, gap: 1 }}>
            <IconButton sx={{
              color: "#fff",
              backgroundColor: "#1d2c61",
              p: 1,
              transition: "transform 0.2s ease",
              "&:hover": { transform: "translateY(-3px)" }
            }}>
              <Facebook />
            </IconButton>
            <IconButton sx={{
              color: "#fff",
              backgroundColor: "#1d2c61",
              p: 1,
              transition: "transform 0.2s ease",
              "&:hover": { transform: "translateY(-3px)" }
            }}>
              <XIcon />
            </IconButton>
            <IconButton sx={{
              color: "#fff",
              backgroundColor: "#1d2c61",
              p: 1,
              transition: "transform 0.2s ease",
              "&:hover": { transform: "translateY(-3px)" }
            }}>
              <Instagram />
            </IconButton>
          </Box>
        </Grid>
      </Grid>

      {/* LOWER SECTION */}
      <Box
        sx={{
          mt: 6,
          pt: 4,
          borderTop: "2px solid #eee",
          color: "#333",
          fontSize: "14px",
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} sm={6}>
            <Box
              component="ul"
              sx={{ listStyle: "none", p: 0, m: 0, textAlign: "left" }}
            >
              <li>
                <Link
                  sx={{ color: "#1d2c61", "&:hover": { color: "#3a5aa8" } }}
                  underline="none"
                  href="/privacyPolicies"
                >
                  <b>Privacy Policy</b>
                </Link>
              </li>

              <li>
                <Link
                  sx={{ color: "#1d2c61", "&:hover": { color: "#3a5aa8" } }}
                  underline="none"
                  href="/termsConditions"
                >
                  <b>Terms & Conditions</b>
                </Link>
              </li>

              <li>
                <Link
                  sx={{ color: "#1d2c61", "&:hover": { color: "#3a5aa8" } }}
                  underline="none"
                  href="/amlPolicies"
                >
                  <b>AML Policies</b>
                </Link>
              </li>
            </Box>
          </Grid>

          <Grid
            item
            size={8}
            sm={6}
            display="flex"
            justifyContent={{
              xs: "flex-start",
              sm: "flex-end",
              md: "flex-end",
            }}
            flexWrap="wrap"
            gap={2}
          >
            <Link
              component="button"
              onClick={() => setComingSoonOpen(true)}
              sx={{ display: "inline-block", lineHeight: 0 }}
            >
              <img
                src="Images/FooterImages/png-clipart-app-store-google-play-apple-apple-text-logoo.png"
                style={{ width: "150px", height: "40px" }}
                alt="Download on the App Store"
              />
            </Link>
            <Link
              href="https://play.google.com/store/apps/details?id=com.metaquantpro.app"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: "inline-block", lineHeight: 0 }}
            >
              <img
                src="Images/FooterImages/png-clipart-app-store-google-playy-apple-apple-text-lo.png"
                style={{ width: "150px", height: "40px" }}
                alt="Get it on Google Play"
              />
            </Link>
          </Grid>
        </Grid>

        {/* Risk Warning Section */}
        <Box mt={4} textAlign="left">
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom sx={{ color: "#1a1a2e" }}>
            Clients must be at least 18 years old to use the services of HC
            Finvest.
          </Typography>
          <Typography variant="body2" fontSize="12px" sx={{ color: "rgba(0,0,0,0.6)" }}>
            <b>Heddge Capitals Wealth Management LLC</b>, operating under the
            brand name HC Finvest, is a legally registered company under the
            Financial Services Authority (FSA) in St. Vincent and the Grenadines
            with registration number 3970, in accordance with the provisions of
            the Companies Act, Chapter 151 of the Revised laws of St. Vincent
            and the Grenadines, 2001. We are authorized to provide forex trading
            services globally, ensuring compliance with applicable laws.
          </Typography>

          <Typography mt={2} fontSize="12px" sx={{ color: "rgba(0,0,0,0.6)" }}>
            <b>RISK WARNING:</b> Forex and Contracts for Difference (CFDs) are
            complex financial instruments that carry a high level of risk and
            are not suitable for all investors. Please carefully consider your
            financial situation, trading experience, and risk tolerance before
            trading.
          </Typography>
        </Box>
      </Box>

      <ComingSoonSnackbar
        open={comingSoonOpen}
        onClose={() => setComingSoonOpen(false)}
        message="iOS App is launching soon — stay tuned!"
      />
    </Box>
  );
};

export default Footer;
